import { useEffect } from 'react';
import type { ModalProps } from '~/modal/modalType.enum';
import type { DataLayerId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';
import { useDataLayersEditViaBTG } from '../useDataLayersEditViaBTG';
import { DataLayerStyleEditModalComponent } from './dataLayerStyleEditModal.component';

export type DataLayerStyleEditModalProps = ModalProps<{
  dataLayerId: DataLayerId;
}>;

export const DataLayerStyleEditModalContainer = ({
  dataLayerId,
  ...modalProps
}: DataLayerStyleEditModalProps) => {
  const {
    dataLayer,
    boundaryTerritoryGroup,
    updateBoundaryTerritoryGroup,
    onSubmit,
  } = useDataLayersEditViaBTG(dataLayerId);

  const onSubmitClick = () => {
    onSubmit();
    modalProps.onClose();
  };

  useEffect(() => {
    if (!dataLayer) {
      modalProps.onClose();
    }
  }, [dataLayer, modalProps]);

  if (!dataLayer || !boundaryTerritoryGroup) {
    return null;
  }

  return (
    <DataLayerStyleEditModalComponent
      boundaryTerritoryGroup={boundaryTerritoryGroup}
      onBoundaryTerritoryGroupChange={updateBoundaryTerritoryGroup}
      onSubmitClick={onSubmitClick}
      {...modalProps}
    />
  );
};
